import { connect } from 'react-redux'
import {onEditMode} from '../actions'
import {IconCube, IconRoute2 } from '@tabler/icons-react';

import PathEditor from './path/index.jsx';
import Object3DEditor from './UI3D';
import ControlObject from "./UI3D/ControlObject"
import {
    Button,
    Group
  } from "@mantine/core";

let  UserAdminInterface = (props)=> {

    return (
        <>
             <Group style={{width: "180px", position: "absolute", zIndex: "220", top: "1rem", left: "1rem", "background": "transparent"}} justify="center">
                <Button leftSection={<IconCube size={14} />} variant={props.editMode==='3d' ? "" : "default"} onClick={()=>{props.onEditMode('3d')}}>3D</Button>
                <Button leftSection={<IconRoute2 size={14} />} variant={props.editMode==='paths' ? "" : "default"} onClick={()=>{props.onEditMode('paths')}}>Path</Button>
             </Group>
             
             <PathEditor objectsScene={props.objectsScene}/>
             <Object3DEditor objectsScene={props.objectsScene} objectSelection={props.objectSelection}/>
             <ControlObject objectSelection={props.objectSelection}/>
        </>
    )
}

const mapDispatchToProps = {
  onEditMode: onEditMode
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode
    }
}


UserAdminInterface = connect(mapStateToProps, mapDispatchToProps)(UserAdminInterface);

export default UserAdminInterface;